import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import { ShopData } from 'types/api/customer.type';

import type { RootState } from '../store';

const shopsAdapter = createEntityAdapter({
  selectId: (shop: ShopData) => shop.id,
});

export const shopsSlice = createSlice({
  name: 'shops',
  initialState: shopsAdapter.getInitialState(),
  reducers: {
    setAllShops(state, action) {
      shopsAdapter.setAll(state, action.payload);
    },
    setShop(state, action) {
      shopsAdapter.setOne(state, action.payload);
    },
    removeShop(state, action) {
      shopsAdapter.removeOne(state, action.payload);
    },
  },
});

export const getState = (rootState: RootState) => rootState.shops;

export const shopsSelector = shopsAdapter.getSelectors((state: RootState) => state.shops);

export const { setAllShops, setShop, removeShop } = shopsSlice.actions;
